import React, { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import useDteTestRequirements from '../../hooks/dte/useDteTestRequirements';
import TestRequirementsTable from '../../components/DTE/TestRequirementsTable';

const DteTestRequirementPage: React.FC = () => {
  const { list, fetchTestRequirements } = useDteTestRequirements();

  useEffect(() => {
    fetchTestRequirements();
  }, []);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <TestRequirementsTable data={list} />
    </DefaultLayout>
  );
};

export default DteTestRequirementPage;
